var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoFullDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 36,
    viewBox: "0 0 237 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5591_119479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 36V0H26.5422C30.3621 0 33.1481 0.765372 34.9002 2.29153C36.6477 3.8177 37.5215 5.66467 37.5215 7.8233V9.65652C37.5215 11.3293 37.1646 12.7043 36.4556 13.7813C35.7419 14.8629 34.9825 15.6237 34.1682 16.0728C35.9569 16.6457 37.3796 17.6311 38.441 19.0381C39.4977 20.4451 40.0284 22.2875 40.0284 24.5698V25.6698C40.0284 26.8934 39.8866 28.1125 39.6029 29.3362C39.3193 30.5599 38.7795 31.669 37.9881 32.6681C37.1967 33.6672 36.0759 34.4693 34.6303 35.0834C33.1847 35.6929 31.3045 36 28.9851 36H0ZM8.05142 14.4275H25.2613C26.6841 14.4687 27.7408 14.1113 28.4362 13.3596C29.1269 12.608 29.4746 11.6593 29.4746 10.5181V9.90859C29.4746 8.97365 29.1498 8.0662 28.5002 7.18625C27.8506 6.31088 26.6292 5.87091 24.8405 5.87091H8.05142V14.4275ZM8.05142 30.1383H27.2742C28.8204 30.1383 29.9915 29.7533 30.783 28.9787C31.5744 28.2042 31.9724 27.1455 31.9724 25.8027V24.7027C31.9724 23.4378 31.5058 22.4112 30.568 21.6137C29.6301 20.8209 28.0885 20.4222 25.9292 20.4222H8.05142V30.1428V30.1383Z",
    fill: "#1E2F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.024 0.0595703L122.652 32.9752L109.458 18.0298L122.94 3.66644L125.319 0.0595703H115.556L103.722 13.5659H103.049L91.2741 0.0595703H81.5117L97.3767 18.0298L83.8311 32.3335L81.5117 36H91.2741L103.049 22.3699H103.722L115.556 36H130.054L134.02 28.2363H155.864L159.464 36H168.86L151.042 0.0595703H139.024ZM136.22 22.2462L144.638 5.55925H145.246L153.604 22.2462H136.216H136.22Z",
    fill: "#1E2F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.238 0.0595799L218.207 11.4898L215.403 15.2799H214.79L211.986 11.4898L202.955 0.0595799H200.727V0H160.827V5.86633H176.692L176.752 36H184.803V5.86633H198.097L210.947 21.0867V36H219.003V21.3342L234.621 3.73062L237 0.0595799H227.238Z",
    fill: "#1E2F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8636 0.224609H49.7637V7.33753H56.8636V0.224609Z",
    fill: "url(#paint0_linear_5591_119479)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9632 0.224609H56.8633V7.33753H63.9632V0.224609Z",
    fill: "url(#paint1_linear_5591_119479)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0628 0.224609H63.9629V7.33753H71.0628V0.224609Z",
    fill: "url(#paint2_linear_5591_119479)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7679 21.5586H42.668V28.6715H49.7679V21.5586Z",
    fill: "url(#paint3_linear_5591_119479)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7679 14.4463H42.668V21.5592H49.7679V14.4463Z",
    fill: "url(#paint4_linear_5591_119479)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7679 7.33301H42.668V14.4459H49.7679V7.33301Z",
    fill: "url(#paint5_linear_5591_119479)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1575 21.5586H71.0576V28.6715H78.1575V21.5586Z",
    fill: "url(#paint6_linear_5591_119479)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1575 14.4453H71.0576V21.5582H78.1575V14.4453Z",
    fill: "url(#paint7_linear_5591_119479)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1575 7.33301H71.0576V14.4459H78.1575V7.33301Z",
    fill: "url(#paint8_linear_5591_119479)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8636 28.667H49.7637V35.7799H56.8636V28.667Z",
    fill: "url(#paint9_linear_5591_119479)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9632 28.667H56.8633V35.7799H63.9632V28.667Z",
    fill: "url(#paint10_linear_5591_119479)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0628 28.667H63.9629V35.7799H71.0628V28.667Z",
    fill: "url(#paint11_linear_5591_119479)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5591_119479",
    x1: 34.315,
    y1: 24.1299,
    x2: 63.5998,
    y2: -7.12806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07EA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03603D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5591_119479",
    x1: 38.1025,
    y1: 27.6772,
    x2: 67.3873,
    y2: -3.57618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07EA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03603D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5591_119479",
    x1: 41.8901,
    y1: 31.2245,
    x2: 71.1749,
    y2: -0.0288513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07EA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03603D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5591_119479",
    x1: 41.1538,
    y1: 30.5368,
    x2: 70.4385,
    y2: -0.721124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07EA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03603D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5591_119479",
    x1: 37.613,
    y1: 27.2193,
    x2: 66.8977,
    y2: -4.03865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07EA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03603D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5591_119479",
    x1: 34.0722,
    y1: 23.9008,
    x2: 63.3569,
    y2: -7.35715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07EA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03603D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5591_119479",
    x1: 56.2997,
    y1: 44.726,
    x2: 85.5845,
    y2: 13.4681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07EA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03603D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5591_119479",
    x1: 52.7589,
    y1: 41.4075,
    x2: 82.0391,
    y2: 10.1495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07EA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03603D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5591_119479",
    x1: 49.2136,
    y1: 38.09,
    x2: 78.4983,
    y2: 6.83661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07EA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03603D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5591_119479",
    x1: 48.4828,
    y1: 37.4023,
    x2: 77.7675,
    y2: 6.14437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07EA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03603D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5591_119479",
    x1: 52.2657,
    y1: 40.9496,
    x2: 81.5505,
    y2: 9.69167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07EA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03603D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5591_119479",
    x1: 56.0533,
    y1: 44.4969,
    x2: 85.3381,
    y2: 13.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07EA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03603D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5591_119479"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 237,
    height: 36,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFullDark);
export default __webpack_public_path__ + "static/media/logo_full_dark.4aad1892b6223d997d3182b3cbbfa5c1.svg";
export { ForwardRef as ReactComponent };